// Depends on: CustTheme-head.js, jQuery

// external jQuery Version:

CustTheme.$ = jQuery;

/* Format elements in header */
CustTheme.headerFormat = function() {
  var self = this;
  var $ = self.$;
  
  var $hotDealsMenu = $('.header-category-menu > nav > .list-menu > li:last-child a');
  $hotDealsMenu.prepend('<i class="icon-hotdeals"></i>');
};

/* Product image fitting */
CustTheme.heightFits = function() {
  var self = this;
  var $ = self.$;
  
  self.addHeightFitGroup('card__inner');
  self.addHeightFitGroup('card-information__text');
  
  if (self.isHome) {
  	self.addHeightFitGroup('home-panel-four-features .title');
  }
};

/* Home Slider */
CustTheme.initSlickSlider = function(selector) {
  var self = this;
  var $ = self.$;

  var $slider = $(selector);
  $slider.slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 980,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
};

CustTheme.parsePriceStr = function(str) {
	var cleanStr = str.slice(str.indexOf('$') + 1).replace(',', '');
  	return Number(cleanStr); 
}

CustTheme.fmtNumberAsPrice = function(num) {
  return num.toLocaleString('en-AU', { 
    style: 'currency',
    currency: 'AUD',
  });
}

CustTheme.watchProductCards = function() {
    if (CustTheme.DEBUG) { console.log('DEBUG: watchProductList...'); }

	var targetNode = document.querySelector('#shopify-section-collection-template .collection-grid > .col-main');
    var config = { childList: true };

    var callback = function(mutationsList, observer) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
              console.log('Something changed!');

            }
        }
    };

    var observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
}

/* Product Cards: Calculate base unit price from regular price */
CustTheme.productCardsPricing = function() {
  var self = this;
  var $ = self.$;
  
  console.log('productCardsPricing()');
  
  var $productCards = $('.card-information');
  $productCards.each(function() {
  	var $card = $(this);
    var $regPrice = $card.find('.price-item--regular');
    var $qtyMeta = $card.find('.card-qty-meta');    
    
    $regPrice.hide();
    self.productBaseUnitPricing($regPrice, $qtyMeta);    
  });
};

/* Product Regular Price -> Unit Qty Price display */
CustTheme.productBaseUnitPricing = function($regPrice, $qtyMeta) {
  var priceStr = $regPrice.text().trim();
  var isVariant = priceStr.startsWith('From');
  var regPrice = CustTheme.parsePriceStr(priceStr);
  var qtyUnits = $qtyMeta.data('units');
  var qtyDiv = Number($qtyMeta.data('division'));
  var qtyMin = Number($qtyMeta.data('min'));

  var unitPrice = regPrice / qtyDiv;
  var displayPrice = (isVariant ? 'From ' : '') + CustTheme.fmtNumberAsPrice(unitPrice) + (qtyUnits !== 'each' ? '/' + qtyUnits : '');    

  $regPrice.after('<span class="price-item price-item--calc">' + displayPrice + '</span>');
};

/* Single Product: Calculate base unit price from regular price */
CustTheme.singleProductPricing = function() {
  var self = this;
  var $ = self.$;  
  
  var $productInfo = $('.product__info-wrapper');
  var $regPrice = $productInfo.find('.price-item--regular').hide();
  var $qtyMeta = $productInfo.find('.prod-qty-meta');
  
  self.productBaseUnitPricing($regPrice, $qtyMeta);
  var $calcPrice = $productInfo.find('.price-item--calc');
  //$calcPrice.css('outline', '1px dashed green');
  
  var priceTemplateSel = '#price-' + $qtyMeta.data('section-id');
  self.watchPriceMutation(priceTemplateSel, function() {    
    $regPrice = $productInfo.find('.price-item--regular');
    self.productBaseUnitPricing($regPrice, $qtyMeta);
    self.recalcQtyPickSingleProduct2(); // v1-2
  });
  
  self.initQtyCalcSingleProduct();
};

/* Single Product: Watch Regular Price for change (variation picking): */
CustTheme.watchPriceMutation = function(priceSel, onMutateCB) {
  var targetNode = document.querySelector(priceSel);
  var config = { childList: true };
  
  var callback = function(mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        onMutateCB();
      }
    }
  };  
  
  var observer = new MutationObserver(callback);
  observer.observe(targetNode, config);    
};

CustTheme.getVariantInfo = function() {
  var self = this;
  var $ = self.$;  
  
  var $variantJson = $('variant-radios [type="application/json"]');
  if ($variantJson.length) {
    return JSON.parse($variantJson.text());
  }

  return null;
};

CustTheme.getCartItems = function() {
  var self = this;
  var $ = self.$;  

  $.getJSON('/cart.js', function(cart) { 
    CustTheme.cartItems = cart.items; // todo add callback
  });
}

/* Single Product: Qty Events */
CustTheme.initQtyCalcSingleProduct = function() {
  var self = this;
  var $ = self.$;  
  
  var $qtyInput = $(".product-form__quantity input[name='quantity']");

  var $qtyNotes = $(".product-form__quantity .qty-notes");
  $qtyNotes.html('');
  
  var $qtyMeta  = $('.product__info-wrapper .prod-qty-meta');    
  var qtyUnits = $qtyMeta.data('units');
  var qtyDiv = Number($qtyMeta.data('division'));
  var qtyMin = Number($qtyMeta.data('min')); 
  var qtyMax = Number($qtyMeta.data('max'));  
  var qtyFixed = $qtyMeta.data('fixed');
  
  var isVarLength = $('#varlength').length !== 0;
  var $vllNotes = $(".product-form__varlength .varlength-limits");  

  self.productId = $qtyMeta.data('product-id');
  
  self.variantData = self.getVariantInfo();
  if (self.variantData) {
    // Is a variant:
    self.defaultVariantId = self.variantData[0].id;
  } else {
    // Is simple product:
  }
  
  var isFixedLength = false;
  if (qtyFixed.length !== 0) {
  	var fOpts = qtyFixed.split(',');
    var qtyFixed = [];    
    for (var oi = 0; oi < fOpts.length; oi++) { 
      qtyFixed[oi] = CustTheme.fmtDivQty(parseInt(fOpts[oi], 10) * qtyDiv); 
    }
    isFixedLength = true;
  }
  
  if (isVarLength) {
  	$vllNotes.html('');
  }
    
  //console.log([qtyUnits, qtyDiv, qtyMin, qtyMax, qtyFixed, isVarLength]);
  
  if (qtyMax !== 0) {    
    if (qtyFixed.length) {
      var qtyOpts = qtyFixed.join(', ') + qtyUnits;
      $qtyNotes.hide();
      //$qtyNotes.html('Select from ' + qtyOpts + '');
    } else {
      var displayMin = CustTheme.fmtDivQty(qtyMin * qtyDiv);
      var displayMax = CustTheme.fmtDivQty(qtyMax * qtyDiv);  
      $qtyNotes.html('Select from ' + displayMin + '-' + displayMax + qtyUnits);      
      
      if (isVarLength) {
        $vllNotes.html('Enter length between ' + displayMin + '-' + displayMax + qtyUnits);      
        $qtyNotes.html('').hide();
      }
    }
  }
  
  var $qtyControls = $(".product-form__quantity quantity-input");
  $qtyControls.after('<div class="quantity-calc">=</div>');
  
  $qtyInput.on('keyup', function(e) {
    var $i = $(this);
    var istr = $i.val();
    var ii = parseInt(istr);

    if (!isNaN(ii) && ('' + ii != istr)) {
      $i.val(ii);  
    }
  });  
  $qtyInput.bind('input', function(e) {
  	self.recalcQtyPickSingleProduct2(); // v1-2
  });  
  
  var $decButton = $(".product-form__quantity button[name='minus']");
  $decButton.on('click', function(e) {
    self.recalcQtyPickSingleProduct2('-'); // v1-2
  });
               
  var $incButton = $(".product-form__quantity button[name='plus']");    
  $incButton.on('click', function(e) {
    self.recalcQtyPickSingleProduct2('+'); // v1-2
  });  
  
  self.initQtyDivPicker2(); // v1-2
  
  self.recalcQtyPickSingleProduct2(); // v1-2
  
  if (isVarLength) {
    self.initVarLengthInput();
    
  } else if (isFixedLength) {
  	self.initFixedLengthSelect();
  }
};


CustTheme.recalcQtyPickSingleProduct2 = function(delta) {
  var self = CustTheme;
  var $ = self.$; 
  
  var $qtyInput  = $(".product-form__quantity input[name='quantity']");
  var $qtyDivPickerInput = $(".product-form__quantity input.qty-div-picker");
  var $regPrice = $('.product__info-wrapper .price-item--regular');
  var $qtyMeta  = $('.product__info-wrapper .prod-qty-meta');
  var $qtyOutput = $('.product__info-wrapper .quantity-calc');
  var $lengthQtyInput = $('#lengthqty');
  var $cartInstance = $('#cartinstance');

  var priceStr = $regPrice.text().trim();
  var regPrice = CustTheme.parsePriceStr(priceStr);
  var qtyUnits = $qtyMeta.data('units');
  var qtyDiv = Number($qtyMeta.data('division'));
  var qtyMin = Number($qtyMeta.data('min'));
  var qtyMax = Number($qtyMeta.data('max'));
  var qtyFixed = $qtyMeta.data('fixed');

  var isVarLength = $('#varlength').length !== 0;
  var isFixedLength = qtyFixed.length !== 0;

  //console.log([priceStr, regPrice, qtyUnits, qtyDiv, qtyMin, qtyMax, qtyFixed, delta, isVarLength, isFixedLength]);

  var currentVariantId = CustTheme.getUrlParameter('variant'); 
  if (!currentVariantId) {
    currentVariantId = CustTheme.defaultVariantId
  }
  console.log([self.productId, currentVariantId]);
  // TODO use currentVariantId to match against cart contents.
  
  setTimeout(function() {
    var inputQty = Number($qtyDivPickerInput.val());
      
    if (isNaN(inputQty)) {
    	inputQty = 1;
    }
    
    inputQty = Math.round(inputQty);
    
    if (typeof delta !== 'undefined') {
      switch (delta) {
        case '+':
          inputQty++;
          break;
        case '-':
          inputQty--;
          break;
        default:
      }
    }
    
    if (inputQty < 1) {
    	inputQty = 1;
    }    
    
    $qtyDivPickerInput.val(inputQty);
    
    //console.log('inputQty: ' + inputQty);

    var length = 1.0;
    if (isVarLength) {
        var $varLengthInput = $(".product-form__varlength input.varlength-picker");
        length = Number($varLengthInput.val());
    } else if (isFixedLength) {
        var $selectedOpt = $(".product-form__fixlength select.fixlength-picker option:selected");
        length = Number($selectedOpt.val());
    }

    var scaledQty = Math.round((inputQty * length) / qtyDiv);
    $qtyInput.val(scaledQty);
    
    //console.log("Math.round((" + inputQty + " * " + length + ") / " + qtyDiv + ") = " + scaledQty);

    var displayQty = CustTheme.fmtDivQty(inputQty);

    var cPrice = scaledQty * regPrice;
    
    //console.log(scaledQty + " * " + regPrice + " = " + cPrice);
    
    var lengthWithUnits = length + (qtyUnits !== 'each' ? qtyUnits : '');   
    var lengthQty = qtyUnits !== 'each' ? displayQty + ' x ' + lengthWithUnits : displayQty;
    
    if (isVarLength || isFixedLength) {
    	$lengthQtyInput.val(lengthQty);
    } else {
    	$lengthQtyInput.val('');
    }

    var ci = self.generateUID();
    $cartInstance.val(ci);
    console.log(ci);
    
    var summary = lengthQty + ' @ ' + CustTheme.fmtNumberAsPrice(cPrice);
    $qtyOutput.html(summary);
  }, 250);
};

// TODO: need to capture add to cart events for this to work:
CustTheme.setCartInstanceVal = function($cartInstance) {
  var self = CustTheme;
  var $ = self.$; 

  if (!self.cart) {
    $.getJSON('/cart.js', function(cart) {  
      console.log('Fetch cart...');
      self.cart = cart;
      var ci = '#' + (self.cart.items.length + 1);
      $cartInstance.val(ci);
      console.log('ci: ' + ci);
    });
    
  } else {
    var ci = '#' + (self.cart.items.length + 1);
    $cartInstance.val(ci);   
    console.log('ci: ' + ci);
  }
};

CustTheme.generateUID = function() {
    var firstPart = (Math.random() * 46656) | 0;
    var secondPart = (Math.random() * 46656) | 0;
    firstPart = ("000" + firstPart.toString(36)).slice(-3);
    secondPart = ("000" + secondPart.toString(36)).slice(-3);
    return firstPart + secondPart;
};

CustTheme.getCart = function() {
  var self = CustTheme;
  var $ = self.$; 
  
  $.getJSON('/cart.js', function(cart) {  
    self.cart = cart.item_count;
  });
};

CustTheme.fmtDivQty = function(divQty) {
  divQty = '' + divQty.toFixed(2);
  divQty = '' + Number(divQty);

  return divQty;
};

CustTheme.initQtyDivPicker2 = function() {
    var $qtyDivPickerInput = $(".product-form__quantity input.qty-div-picker");
    var $qtyInput = $(".product-form__quantity input[name='quantity']");

    $qtyDivPickerInput.val(1);

    $qtyDivPickerInput.bind('blur', function(e) {
        CustTheme.recalcQtyPickSingleProduct2();
    });
};

CustTheme.recalcQtyDivPicker = function() { // TODO: this 'rewrites' the visible qty, likely no longer needed.
  console.log('DEPRECATED 1');
  var $qtyDivPickerInput = $(".product-form__quantity input.qty-div-picker");
  var $qtyInput  = $(".product-form__quantity input[name='quantity']");
  var $qtyMeta  = $('.product__info-wrapper .prod-qty-meta');
  
  var qty = Number($qtyInput.val());
  var qtyDiv = Number($qtyMeta.data('division'));  
  var divQty = qty * qtyDiv;
  
  divQty = CustTheme.fmtDivQty(divQty);
  
  $qtyDivPickerInput.val(divQty);
};

// TODO v2 DISCARD: CustTheme.recalcQtyDivPicker

CustTheme.initVarLengthInput = function() {
  var self = this;
  var $ = self.$;    
  
  var $varLengthInput = $(".product-form__varlength input.varlength-picker");

  var $qtyMeta  = $('.product__info-wrapper .prod-qty-meta');  
  var qtyDiv = Number($qtyMeta.data('division'));
  var qtyMin = Number($qtyMeta.data('min')); 
  var qtyMax = Number($qtyMeta.data('max'));
    
  // Set to lower bound:
  var displayMin = CustTheme.fmtDivQty(qtyMin * qtyDiv);
  $varLengthInput.val(displayMin);
  
  // Validate:
  self.validateVarLengthInput();
   
  // on Change:
  $varLengthInput.bind('blur', function(e) {    
    self.validateVarLengthInput();
    self.recalcQtyPickSingleProduct2();
  });
};

CustTheme.validateVarLengthInput = function() {
  var self = this;
  var $ = self.$;    
  
  var $qtyMeta  = $('.product__info-wrapper .prod-qty-meta');  
  var qtyDiv = Number($qtyMeta.data('division'));
  var lMin = Number($qtyMeta.data('min')) * qtyDiv; 
  var lMax = Number($qtyMeta.data('max')) * qtyDiv;  
  var displayMin = lMin;
  
  var $varLengthInput = $(".product-form__varlength input.varlength-picker");
    
  var newLen = Number($varLengthInput.val());
  
  if (!isNaN(newLen)) {
    if (newLen < lMin) {
     	newLen = lMin;
    } else if (newLen > lMax) {
    	newLen = lMax;  
    }   
    
    newLen = Number(newLen.toFixed(3));
    
    
  } else {
    newLen = displayMin;
    
  }    
  
  $varLengthInput.val(newLen);
};

CustTheme.initFixedLengthSelect = function() {
  var self = this;
  var $ = self.$;    
  
  var $fixLengthSelect = $(".product-form__fixlength select.fixlength-picker");
  
  // On change:
  $fixLengthSelect.on('change', function() {
    CustTheme.recalcQtyPickSingleProduct2();
  });

};  
  
/* Cart Items: Calculate base unit price from regular price */
CustTheme.cartItemsPricing = function() {
  var self = this;
  var $ = self.$;  
  
  var $cartItems = $('.cart-item');
  $cartItems.each(function() {
  	var $item = $(this);

    self.initQtyCalcCartItem($item);
  });
  
  var priceTemplateSel = '#main-cart-items > .js-contents';
  self.watchPriceMutation(priceTemplateSel, function() {    
    console.log('Cart mutated!');
    setTimeout(function() {
    	CustTheme.recalcQtyCartItems();
    }, 250);
  });    
};

/* Cart Item: Pricing display  */
CustTheme.initCartItemPricing = function($item) {
  var self = this;
  var $ = self.$;  
  
  var $regPrice = $item.find('.cart-item__prices .price');
  var $qtyMeta = $item.find('.cart-item-qty-meta');  
  
  $regPrice.hide();
  self.productBaseUnitPricing($regPrice, $qtyMeta);  
  var $calcPrice = $item.find('.price-item--calc');
};

/* Single Product: Qty Events */
CustTheme.initQtyCalcCartItem = function($item) {
  var self = this;
   
  self.recalcQtyCartItem($item);
};

/* Cart Items: (Re)calculate display:  */
CustTheme.recalcQtyCartItems = function() {
  var self = this;
  var $ = self.$;   
  
  var $cartItems = $('.cart-item');
  $cartItems.each(function() {
  	var $item = $(this);
    self.recalcQtyCartItem($item);
  });  
}

/* Cart Item: (Re)calculate display:  */
CustTheme.recalcQtyCartItem = function($item) {
  var self = this;
  var $ = self.$;   
  
  self.initCartItemPricing($item);
  
  var $qtyInput = $item.find("input.quantity__input");  
  var $regPrice = $item.find('.cart-item__prices .price');
  var $qtyMeta = $item.find('.cart-item-qty-meta');  
  var $qtyControls = $qtyInput.parent();   
  
  var priceStr = $regPrice.text().trim();
  var regPrice = CustTheme.parsePriceStr(priceStr);
  var qtyUnits = $qtyMeta.data('units');
  var qtyDiv = Number($qtyMeta.data('division'));
  var qtyMin = Number($qtyMeta.data('min')); 
  var qtyMax = Number($qtyMeta.data('max'));  
  
  var $lengthQty = $item.find(".product-option[data-prop='LengthQty']");
  
  var qty = Number($qtyInput.val());
  
  //console.log('qty=' + qty);

  //console.log([priceStr, regPrice, qtyUnits, qtyDiv, qtyMin, qtyMax, qty]);  
  
  $qtyControls.hide();
  $qtyControls.after('<div class="quantity-calc">#QTY#</div>');
  var $qtyOutput = $item.find('.quantity-calc');
  
  var dim = qty * qtyDiv;
  dim = '' + dim.toFixed(2);
  dim = dim.replace('.00', '');

  //console.log('dim=' + dim);
  
  var cPrice = qty * regPrice;
  var qtyDesc = dim + (qtyUnits !== 'each' ? qtyUnits : '');
  
  if ($lengthQty.length) {
    $lengthQty.find('dt').html('Qty, Length:');
    var qtyBdStr = $lengthQty.find('dd').text();
    //console.log(qtyBdStr);
    var xPos = qtyBdStr.indexOf('x');
    if (xPos > 0) {
        var unitPos = qtyBdStr.indexOf(qtyUnits);
        var lenPos = xPos + 2;
        var lenLen = unitPos - lenPos;
      	if (lenLen > 0) {
    		var pLen = Number(qtyBdStr.substr(lenPos, lenLen));
    		//console.log([pLen, qtyUnits]);
            var pcs = dim / pLen;
            qtyDesc = pcs + ' x ' + pLen + qtyUnits;
        }
    }
  }
    
  var qtyDisplay = qtyDesc; /* + ' @ ' + CustTheme.fmtNumberAsPrice(cPrice);*/
  $qtyOutput.html(qtyDisplay);     
}

/*
	TODO: watch and overwrite cart count bubble with # cart items, not total qty
*/


CustTheme.watchProductList = function() {
    if (CustTheme.DEBUG) { console.log('DEBUG: watchProductList...'); }

	var targetNode = document.querySelector('#CollectionProductGrid');
  
	if (!targetNode) {
      return; 
    }
  
    var config = { childList: true };

    var callback = function(mutationsList, observer) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
              //console.log('Something changed!');
			  CustTheme.productCardsPricing();
              CustTheme.updateHeightFitGroups();
            }
        }
    };

    var observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
}

/********************************************/

CustTheme.initFoot = function() {
  var self = this;
  var $ = self.$;

  self.$body = $('body');
  self.isHome = self.$body.hasClass('t-index');
  self.isSingleProduct = self.$body.hasClass('t-product');
  self.isCart = self.$body.hasClass('t-cart');  
  self.hasProductCards = self.$body.find('.card--product').length !== 0;
  
  self.headerFormat();
  
  if (self.hasProductCards) {
  	self.productCardsPricing();  
    self.watchProductList();
  }
  
  if (self.isSingleProduct) {
  	self.singleProductPricing();
  }
  
  if (self.isCart) {
  	self.cartItemsPricing();
  }  
  
  if (self.isHome) {
  	self.initSlickSlider('slider-component > ul.slider');
  }
  
  self.heightFits();

  if (self.DEBUG) { console.log('CustTheme.initFoot() done.'); }
};
(function() { CustTheme.initFoot(); })();

CustTheme.initFootOnDocReady = function() {
  var self = this;
  var $ = self.$;

  self.updateHeightFitGroups();

  if (self.DEBUG) { console.log('CustTheme.initFootOnDocReady() done.'); }
};
CustTheme.$(function() { CustTheme.initFootOnDocReady(); });

CustTheme.initFootOnWindowLoad = function() {
  var self = this;
  var $ = self.$;

  self.updateHeightFitGroups();
  
  setTimeout(function() {
    self.updateHeightFitGroups();
  }, 2000);

  if (self.DEBUG) { console.log('CustTheme.initFootOnWindowLoad() done.'); }
};
jQuery(window).on("load", function() { CustTheme.initFootOnWindowLoad(); });

CustTheme.onWindowResize = function() {
  var self = this;
  var $ = self.$;

  self.getViewport();  
  self.updateHeightFitGroups();
};
jQuery(window).resize(function() { CustTheme.onWindowResize(); });
